var React = require('react');

function HamburgerMenu (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z","key":1})]);
}

HamburgerMenu.displayName = "HamburgerMenu";

HamburgerMenu.defaultProps = {"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = HamburgerMenu;

HamburgerMenu.default = HamburgerMenu;



//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/HamburgerMenu.svg
// module id = 643
// module chunks = 168707334958949